import { getCurrentUser } from "../../lib/authSession";

const KEY = (companyId) =>
  companyId ? `repman-onboarding-complete-v1:c-${companyId}` : null;

export function isOnboardingComplete(companyId = getCurrentUser()?.company?.id) {
  const key = KEY(companyId);
  if (!key || typeof window === "undefined") return false;
  return window.localStorage.getItem(key) === "1";
}

export function markOnboardingComplete(companyId = getCurrentUser()?.company?.id) {
  const key = KEY(companyId);
  if (!key || typeof window === "undefined") return;
  window.localStorage.setItem(key, "1");
}

export function resetOnboarding(companyId = getCurrentUser()?.company?.id) {
  const key = KEY(companyId);
  if (!key || typeof window === "undefined") return;
  window.localStorage.removeItem(key);
}
